<template>
  <l-cache :get-data="getItem" :id="$route.query.id" ref="cache">
    <reservation-group-content :data="data" slot-scope="{data}" @refresh="$refs.cache.retry()">
      <template slot="title-actions">
        <v-btn @click="$refs.cache.retry()" class="mx-0" color="primary" flat>刷新</v-btn>
      </template>
    </reservation-group-content>
  </l-cache>
</template>
<script>

import ReservationGroupContent from './groupContent'

export default {
  name: 'PersonReservationGroupDetails',
  components: {ReservationGroupContent},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('personReservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: key},
        locate: this.$route.query.history ? 'history' : 'runtime'
      })
      console.log(items)
      if (items.length) {
        let item = items[0]
        item.editInfo = false
        item.loading = false
        return item
      }
      else {
        this.$L.alert('error', '未找到该预约分组')
      }
    }
  }
}
</script>

<style scoped>

</style>
